import { ImportCandidateDto } from '../import-candidate-dto';
import { PackagingSystemDto } from './packaging-system-dto';

export class ImportPackagingSystemCandidateDto extends ImportCandidateDto {
    packagingSystem!: PackagingSystemDto;
}
